import { render, staticRenderFns } from "./q-abc.vue?vue&type=template&id=2e965df4&scoped=true&"
import script from "./q-abc.vue?vue&type=script&lang=js&"
export * from "./q-abc.vue?vue&type=script&lang=js&"
import style0 from "./q-abc.vue?vue&type=style&index=0&id=2e965df4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e965df4",
  null
  
)

export default component.exports